export default __webpack_public_path__ + "d5b938b30366eb5e34fa0a3e095b43f4.svg";